<template>
  <div class="doc-tree">
    <div class="btn-wraper">
      <div class="btn">
        <DocSvg />
        <span>我的文档</span>
      </div>
      <div>
        <AddSvg class="plus" @click="addTopLevel" />
      </div>
    </div>

    <el-tree ref="mytree" :data="dataSource" :load="loadNode" node-key="id" lazy accordion highlight-current
     :expand-on-click-node="false" @node-click="handleNodeClick">
      <div class="tree-node" slot-scope="{ node, data }">
        <div v-if="data.id">
          <div class="label">{{ data.label }}</div>
        </div>
        <div v-else>
          <div class="empty-label">{{ data.label }}</div>
        </div>
        <div v-if="data.id">
          <AddSvg class="plus" @click.stop="append(node, data)" />
          <CloseSvg class="plus" @click.stop="remove(node, data)" />
        </div>
      </div>
    </el-tree>
    <div class="btn" style="margin-top: 1rem; cursor: pointer;">
      <RecycleSvg />
      <span>回收站</span>
    </div>
    <el-tree ref="recycletree" :data="deletedSource" node-key="id" lazy accordion highlight-current
      :expand-on-click-node="false" @node-click="handleNodeClick">
      <div class="tree-node" slot-scope="{ node, data }">
        <div v-if="data.id">
          <div class="label">{{ data.label }}</div>
        </div>
        <div v-else>
          <div class="empty-label">{{ data.label }}</div>
        </div>
      </div>
    </el-tree>
  </div>
</template>
<script>
import DocSvg from '@/assets/svg/doc.svg'
import AddSvg from '@/assets/svg/add.svg'
import CloseSvg from '@/assets/svg/close.svg'
import RecycleSvg from '@/assets/svg/recycle.svg'
import { getChildren, getRecycled, saveDocument, deleteDocument } from '@/api/document'
import { mapState } from 'vuex'

export default {
  components: { DocSvg, AddSvg, RecycleSvg, CloseSvg },
  mounted() {
    this.initData()
    this.loadDeletedSource()
  },
  computed: {
    ...mapState({
      selectedDocName: state => state.user.selectedDocName
    })
  },
  watch: {
    selectedDocName(val, oldVal) {
      if (val) {
        this.updateCurrentNodeLabel(val)
      }
    }
  },
  methods: {
    async initData() {
      const res = await getChildren()
      console.log('res', res)
      if (res.data) {
        const docs = []
        res.data.forEach(item => {
          docs.push({
            id: item.id,
            label: item.name,
            children: []
          })
        })
        this.dataSource = docs
        console.log('data', this.dataSource)
      }
    },
    async loadDeletedSource() {
      const recycledRes = await getRecycled()
      console.log('recycledRes', recycledRes)
      if (recycledRes.data) {
        const docs = []
        recycledRes.data.forEach(item => {
          docs.push({
            id: item.id,
            label: item.name,
            children: []
          })
        })
        this.deletedSource = docs
        console.log('deletedSource', this.deletedSource)
      }
    },
    handleNodeClick(data) {
      this.$store.commit('user/SET_SELECTED_DOC_ID', data.id)
    },
    updateCurrentNodeLabel(label) {
      const node = this.$refs.mytree.getCurrentNode()
      console.log('node', node)
      if (node) {
        node.label = label
      }
    },
    loadNode(node, resolve) {
      console.log('node', node)
      if ((node.level === 0) || (!node.data.id)) {
        console.log('skip load')
        resolve([])
      } else {
        getChildren(node.data.id).then(res => {
          console.log('res', res)
          if (res.data) {
            const docs = []
            res.data.forEach(item => {
              docs.push({
                id: item.id,
                label: item.name,
                children: []
              })
            })
            resolve(docs)
          } else {
            resolve([])
          }
        })
      }
    },
    createDocHelper(parentId, callback) {
      this.$prompt('请输入文档名称', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /\S/,
        inputErrorMessage: '文档名称不能为空'
      }).then(({ value }) => {
        console.log('value', value)
        saveDocument({
          name: value,
          parent: parentId
        }).then(res => {
          console.log('res', res)
          callback(res)
          this.$message({
            type: 'success',
            message: '创建成功'
          })
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消创建'
        })
      })
    },
    addTopLevel() {
      this.createDocHelper('', res => {
        this.initData()
      })
    },
    append(node, data) {
      this.createDocHelper(data.id, res => {
        const newChild = { id: res.data.Id, label: res.data.Name, children: [] }
        if (!data.children) {
          data.children = []
        }
        // data.children.push(newChild)
        // this.dataSource = [...this.dataSource]
        this.$refs.mytree.append(newChild, data)
      })
    },
    remove(node, data) {
      if (!data.id) {
        return
      }
      console.log('remove', node, data)
      this.$confirm('确认删除文档吗?', '确认', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteDocument({
          id: data.id
        }).then(res => {
          console.log('res', res)
          this.$refs.mytree.remove(data)
          this.$message({
            type: 'success',
            message: '删除成功'
          })
          this.loadDeletedSource()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消删除'
        })
      })
    }
  },
  data() {
    return {
      dataSource: [],
      deletedSource: []
    }
  }
}
</script>
<style lang="scss" scoped>
.doc-tree {

  .btn {
    display: flex;
    align-items: center;

    span {
      padding-left: 0.4rem;
      font-size: 0.88rem;
    }
  }

  .btn-wraper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 1rem;
    margin-bottom: 0.5rem;

    .plus {
      width: 0.75rem;
      height: 0.75rem;
      cursor: pointer;
      padding-left: 0.4rem;
    }
  }

  .tree-node {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;

    .label {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: 120px;
      color: #333;
      padding-left: 0.4rem;
      font-size: 0.88rem;
    }

    .empty-label {
      font-size: 0.50rem;
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: 120px;
      color: #848383;
    }

    .plus {
      width: 0.8rem;
      height: 0.8rem;
      cursor: pointer;
    }
  }
}
</style>
